import type { IconProps } from './types/types';

const TypeformIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 7.88364C0 5.32364 1.01091 4 2.70545 4C4.40727 4 5.41818 5.32364 5.41818 7.88364V15.6364C5.41818 18.1964 4.4 19.52 2.70545 19.52C1.01091 19.52 0 18.1964 0 15.6364V7.88364ZM18.24 4H12.64C7.62182 4 7.22909 6.16727 7.22909 9.06182L7.22182 14.4582C7.22182 17.4691 7.6 19.52 12.6618 19.52H18.24C23.2727 19.52 23.6436 17.36 23.6436 14.4727V9.06909C23.6436 6.16727 23.2582 4 18.24 4Z"
      fill="black"
    />
  </svg>
);

export default TypeformIcon;
